/**
 * Following the reducer patternto manage context state from reach-ui `MenuButton`
 * https://github.com/reach/reach-ui/tree/main/packages/menu-button
 *
 */
var CLOSE_TOGGLETIP = "CLOSE_TOGGLETIP";
var OPEN_TOGGLETIP = "OPEN_TOGGLETIP";
var SET_BUTTON_ID = "SET_BUTTON_ID";

export { CLOSE_TOGGLETIP, OPEN_TOGGLETIP, SET_BUTTON_ID };
//# sourceMappingURL=actions.js.map
